<!-- <p>water-usage works!</p> -->
<div class="row">
    <div class="col-xl-9 mb-4">

    </div>
    <div class="col-xl-3 mb-4 ct_mt_top_68">

        <div class="ct_right_sidebar">
            <div class="mb-4">
                <div>
                    <ng-container   *ngIf="dashboardFacilities$ | async as dashboardData">
                        <p-dropdown class="ct_select_op_input ct_chev_icon_dark230" required  #country="ngModel"
                        [options]="dashboardData.categories" optionLabel="AssestType" 
                        optionValue="ID" [(ngModel)]="selectedFacility" [ngModelOptions]="{standalone: true}" [scrollable]="true"
                        (onChange)="onFacilityChange($event)">
                        <ng-template let-option pTemplate="item">
                            <div class="d-flex justify-content-between">
                              <div>{{ option.AssestType }}</div>
                              <div class="d-flex justify-content-end pt-1 ml-1">
                                <i class="fa" [class.fa-users]="isArray(option.ID)" [class.fa-user]="!isArray(option.ID)"></i>
                              </div>
                            </div>
                          </ng-template>
                    </p-dropdown>
                    </ng-container>
                    <div class="mt-4">
                        <p class="mb-1 ct_fw_500 ">Calendar Year</p>
                        <p-calendar class="w-100 ct_input_dark_text_145" [(ngModel)]="year" ngModel name="year" year
                            (ngModelChange)="onFacilityChange($event)" view="year" dateFormat="yy" inputId="yearpicker"
                            styleClass="pcalender" [showIcon]="true"></p-calendar>
                        <!-- <select class="ct_period_select w-100">
                            <option value="">2023-2024</option>
                            <option value="">2023-2024</option>
                        </select> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-xl-12">
        <div class="row">

            <div class="col-xl-3 mb-4">
                <div class="ct_dark_grey_bg1 mb-4">
                    <h4>Waste disposed </h4>
                    <div class="row pt-3">
                        <div class="col-lg-6 mb-2">
                            <h5>{{UpWaste}}</h5>
                        </div>
                    

                    </div>
                </div>
                <div class="ct_dark_grey_bg1 mb-4">
                    <h4>Emissions from Waste </h4>
                    <div class="row  pt-3">
                        <div class="col-lg-6 mb-2">
                            <h5>{{downWaste}}</h5>
                        </div>
                      

                    </div>
                </div>
                <div class="ct_dark_grey_bg1 mb-4">
                    <h4> Waste Diversion </h4>
                    <div class="row  pt-3">
                        <div class="col-lg-6 mb-2">
                            <h5>{{wasteDiversion}}</h5>
                        </div>
                      

                    </div>
                </div>
            </div>
            <!-- <div class="col-xxl-3 mb-4">
                <div class="ct_grey_border_1 ">
                    <div class="ct_d_flex_1 ct_grey_brdr_btm1 pb-3 mb-3">
                        <div>
                            <h5 class="ct_font_16"><strong>Cost Centre</strong></h5>
                            <h3 class="ct_fs_24"><strong>5.987,34</strong></h3>
                            <p class="mb-0">tCO2e</p>
                        </div>
                        <div class="ct_info_icon">
                            <i class="fa-solid fa-info"></i>
                        </div>
                    </div>
                    <div id="ct_emission_by_travel">
                        <apx-chart
                        [series]="chartOptions.series"
                        [chart]="chartOptions.chart"
                        [labels]="chartOptions.labels"
                        [responsive]="chartOptions.responsive"
                      ></apx-chart>
                    </div>
                </div>
            </div> -->
            <div class="col-xl-3  mb-4">
                <div class="ct_grey_border_1 h-auto" style="height: 436px !important;">
                    <div class="ct_d_flex_1 ct_grey_brdr_btm1 pb-3 mb-3 ">
                        <div>
                            <h5 class="ct_font_16"><strong>Emissions from Waste types</strong></h5>
                            <!-- <h3><strong>{{totaltype | number:'1.2-2'}}</strong></h3> -->
                            <p class="mb-0">tCO2e</p>
                        </div>

                    </div>
                 


                    <div class="ct_emission_vender_list">
                        <div class="d-flex  ct_emission_vender_list_item_12 align-items-center gap-2 justify-content-between "
                            *ngFor="let vendorItems of topFIveE">
                            <div>
                                <h5 class="mb-1">{{vendorItems.wasteName}}</h5>
                            </div>
                            <div>
                                <p class="mb-0 d-flex align-items-center">{{vendorItems.emission | number:'1.4-4'}}&nbsp;
                                    {{vendorItems.unit}} </p>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
            <div class="col-xl-6 mb-4">
                <div class="ct_grey_border_1 h-auto ">
                    <div class="ct_d_flex_1 ct_grey_brdr_btm1 pb-3 mb-3">
                        <div>
                            <h5 class="ct_font_16"><strong>Hazardous & Non Hazardous waste</strong></h5>
                            <!-- <h3><strong>{{hazardTotal | number:'1.2-2'}}</strong></h3> -->
                            <p class="mb-0">tCO2e</p>
                        </div>

                    </div>
                    <div id="ct_emission_by_month" *ngIf="donotOptions4">
                        <div id="ct_cost_center" *ngIf="donotOptions4">
                            <apx-chart [series]="donotOptions4.series" [chart]="donotOptions4.chart"
                                [labels]="donotOptions4.labels" [legend]="donotOptions4.legend"
                                [responsive]="donotOptions4.responsive"></apx-chart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-4 mb-4">
                <div class="ct_grey_border_1 ">
                    <div class="ct_d_flex_1 ct_grey_brdr_btm1 pb-3 mb-3">
                        <div>
                            <h5 class="ct_font_16"><strong>Treatment methods</strong></h5>
                            <!-- <h3><strong>{{hazardTotal | number:'1.2-2'}}</strong></h3> -->
                            <p class="mb-0">tCO2e</p>
                        </div>

                    </div>
                    <div id="ct_business_divisions">
                        <div id="ct_cost_center" *ngIf="donotOptions1">
                            <apx-chart [series]="donotOptions1.series" [chart]="donotOptions1.chart"
                                [labels]="donotOptions1.labels" [legend]="donotOptions1.legend"
                                [responsive]="donotOptions1.responsive"></apx-chart>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4  mb-4">
                <div class="ct_grey_border_1">
                    <div class="ct_d_flex_1 ct_grey_brdr_btm1 pb-3 mb-3">
                        <div>
                            <h5 class="ct_font_16"><strong>Waste Diversion Breakdown</strong></h5>
                            <p class="mb-0">tCO2e</p>
                        </div>

                    </div>
                    <div id="ct_cost_center" *ngIf="donotOptions2">
                        <apx-chart
                        [series]="donotOptions2.series"
                        [chart]="donotOptions2.chart"
                        [labels]="donotOptions2.labels"
                        [legend]="donotOptions2.legend"
                        [responsive]="donotOptions2.responsive"
                        [colors]="donotOptions2.colors"
                      ></apx-chart>
                    </div>
                </div>
            </div>
            <div class="col-xl-4  mb-4">
                <div class="ct_grey_border_1">
                    <div class="ct_d_flex_1 ct_grey_brdr_btm1 pb-3 mb-3">
                        <div>
                            <h5 class="ct_font_16"><strong>Waste Emissions by Activity</strong></h5>
                            <p class="mb-0">tCO2e</p>
                        </div>

                    </div>
                    <div id="ct_net_zeo_donut" *ngIf="upDowndonotOptions1">
                        <apx-chart [series]="upDowndonotOptions1.series" [chart]="upDowndonotOptions1.chart"
                            [labels]="upDowndonotOptions1.labels" [colors]="upDowndonotOptions1.colors"
                            [legend]="upDowndonotOptions1.legend"
                            [responsive]="upDowndonotOptions1.responsive"></apx-chart>
                    </div>
                </div>
            </div>

        </div>
    </div>

</div>